import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Checkbox, Container, Divider, FormControlLabel, makeStyles,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import CustomTypography from '../../components/Typography/CustomTypography';
import styles from '../../assets/jss/components/ListCustomLayoutSeminarAndLivestream';
import ListCustomLayout from '../../components/ListCustomLayoutSeminarAndLivestream/ListCustomLayoutSeminarAndLivestream';
import dateUtils from '../../utils/dateUtils';
import Snackbar from '../../components/Snackbar/Snackbar';
import { LIVESTREAM_STATUS_TEXT } from '../../common/Constants';
import { platform, PLATFORM } from '../../utils/getPlatform';

const useStyles = makeStyles(styles);

const ListLiveStreamViewerCustomLayout = ({
    listData,
    loggedIn,
    isWeakAuth,
    eventInfo,
    customColor,
    customText,
    handleViewLiveStream,
    isRegisterLivestreamView,
    registerCheck,
    handleRegisterCheck,
    isRegisterLivestreamAfter3day,
    locale,
}) => {
    const classes = useStyles({ customColor });
    const intl = useIntl();

    const [snackbar, setSnackbar] = useState({ isOpen: false, type: 'success', message: '' });

    const createListView = () => {
        const viewTotal = [];
        (Object.keys(listData).forEach((key) => {
            const viewList = [];
            let viewData = [];
            if (loggedIn && eventInfo.free_live_stream) {
                viewData = (Object.keys(listData[key]).map((index) => {
                    const liveStream = listData[key][index];
                    return (
                        <ListCustomLayout
                            time={`${liveStream.stime}~${liveStream.etime}`}
                            title={liveStream.title}
                            speakerName={liveStream.speaker}
                            speakerProfile={liveStream.streamer_profile}
                            content={liveStream.content}
                            priceItem={liveStream.cost === 0
                                ? intl.formatMessage({ id: 'common.free' })
                                : `${intl.formatNumber(liveStream.cost)}${intl.formatMessage({ id: 'common.yen' })}`}
                            handleViewDetail={liveStream.status === 3 ? (e) => handleViewLiveStream(e, liveStream.id) : handleShowMessage}
                            customColor={customColor}
                            isLiveStream
                        />
                    );
                }));
            } else if (loggedIn && (!isWeakAuth || isWeakAuth === 'false') && !eventInfo.free_live_stream) {
                viewData = (Object.keys(listData[key]).map((index) => {
                    const liveStream = listData[key][index];
                    const disableCheckBox = liveStream.registered ? { color: '#00000042' } : { color: eventInfo?.settings_colors_viewer?.button_background_color?.common_button };
                    return (
                        <ListCustomLayout
                            button={
                                !(!isRegisterLivestreamView(key, liveStream.stime) && !isRegisterLivestreamAfter3day() && !liveStream.registered)
                                    && (
                                        <FormControlLabel
                                            style={{ marginRight: '0px' }}
                                            control={(
                                                <Checkbox
                                                    checked={(registerCheck[liveStream.id] && registerCheck[liveStream.id][liveStream.id]) || liveStream.registered}
                                                    onChange={(e) => handleRegisterCheck(e, liveStream.id, liveStream.cost, liveStream.title)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={disableCheckBox}
                                                />
                                            )}
                                            label={(
                                                <CustomTypography
                                                    variant="h6"
                                                    customColor={customColor?.contents_text_color}
                                                    className={classes.textPrice}
                                                >
                                                    {customText?.field_name?.application_check || intl.formatMessage({ id: 'livestream.apply' })}
                                                </CustomTypography>
                                            )}
                                        />
                                    )
                            }
                            time={`${liveStream.stime}~${liveStream.etime}`}
                            title={liveStream.title}
                            speakerName={liveStream.speaker}
                            speakerProfile={liveStream.streamer_profile}
                            content={liveStream.content}
                            priceItem={liveStream.cost === 0
                                ? intl.formatMessage({ id: 'common.free' })
                                : `${intl.formatNumber(liveStream.cost)}${intl.formatMessage({ id: 'common.yen' })}`}
                            textStatus={LIVESTREAM_STATUS_TEXT[locale][liveStream.status]}
                            isViewDetail={false}
                            customColor={customColor}
                            isLiveStream
                        />
                    );
                }));
            } else {
                viewData = (Object.keys(listData[key]).map((index) => {
                    const liveStream = listData[key][index];
                    return (
                        <ListCustomLayout
                            time={`${liveStream.stime}~${liveStream.etime}`}
                            title={liveStream.title}
                            speakerName={liveStream.speaker}
                            speakerProfile={liveStream.streamer_profile}
                            content={liveStream.content}
                            priceItem={liveStream.cost === 0
                                ? intl.formatMessage({ id: 'common.free' })
                                : `${intl.formatNumber(liveStream.cost)}${intl.formatMessage({ id: 'common.yen' })}`}
                            isViewDetail={false}
                            customColor={customColor}
                            isLiveStream
                        />
                    );
                }));
            }
            viewList.push(viewData);
            const viewCustomList = (
                <Fragment key={key}>
                    {createTitle(key)}
                    {viewList}
                </Fragment>
            );
            viewTotal.push(viewCustomList);
        }));
        return viewTotal;
    };

    const createTitle = (title) => (
        <>
            <GridContainer className={classes.mainContainer}>
                <GridItem>
                    <CustomTypography
                        className={classes.listTitleLiveStream}
                        variant="h5"
                        bold
                        color="white"
                        customColor={customColor?.list_table?.title_text_color}
                    >
                        {dateUtils.formatJa(new Date(title), locale)}
                    </CustomTypography>
                </GridItem>
            </GridContainer>
            <Divider className={classes.dividerUp} />
        </>
    );

    const handleShowMessage = () => {
        setSnackbar({
            ...snackbar,
            isOpen: true,
            type: 'error',
            message: intl.formatMessage({ id: 'livestream.waitingTime' }, {
                namePage: eventInfo.settings_texts_sidebar_viewer?.field_name?.livestreaming
                || intl.formatMessage({ id: 'userRouters.liveStream' }).toLocaleLowerCase(),
            }),
        });
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, isOpen: false });
    };

    return (
        <>
            {platform === PLATFORM.OTHER ? (
                <Container>
                    {createListView()}
                    <Snackbar
                        open={snackbar.isOpen}
                        onClose={handleCloseSnackbar}
                        message={snackbar.message}
                        severity={snackbar.type}
                    />
                </Container>
            ) : (
                <>
                    {createListView()}
                    <Snackbar
                        open={snackbar.isOpen}
                        onClose={handleCloseSnackbar}
                        message={snackbar.message}
                        severity={snackbar.type}
                    />
                </>
            )}
        </>
    );
};

ListLiveStreamViewerCustomLayout.defaultProps = {
    listData: {},
    isWeakAuth: false || undefined,
    eventInfo: {},
    customText: {},
    customColor: {},
    handleViewLiveStream: () => {},
    isRegisterLivestreamView: () => {},
    registerCheck: {},
    handleRegisterCheck: () => {},
    isRegisterLivestreamAfter3day: false,
    locale: 'ja',
};

ListLiveStreamViewerCustomLayout.propTypes = {
    listData: PropTypes.oneOfType([() => null, PropTypes.object]),
    loggedIn: PropTypes.bool.isRequired,
    isWeakAuth: PropTypes.oneOfType([() => PropTypes.bool, PropTypes.string]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    handleViewLiveStream: PropTypes.func,
    isRegisterLivestreamView: PropTypes.func,
    registerCheck: PropTypes.oneOfType([() => null, PropTypes.object]),
    handleRegisterCheck: PropTypes.func,
    isRegisterLivestreamAfter3day: PropTypes.bool,
    locale: PropTypes.string,
};

export default ListLiveStreamViewerCustomLayout;
